export default {
  categories: {
    shoes: 'Shoes',
    hoodies: 'Hoodies / Sweaters',
    tshirts: 'T-Shirts',
    jackets: 'Jackets',
    pants: 'Pants / Shorts',
    headwear: 'Headwear',
    sets: 'Sets',
    underwear: 'Underwear / Underpants',
    jersey: 'Jersey',
    accessories: 'Accessories',
    bags: 'Bags',
    belts: 'Belts',
    perfumes: 'Perfumes',
    other: 'Other Stuff',
  },
  home: {
  hero: {
    badge: 'Independent USFans Spreadsheet Resource',
    h1: 'USFans Spreadsheet — Product Links, QC & Buying Guides',
    subtitle: 'Explore the USFans Spreadsheet for product resources, useful links, QC information, shipping guides, warehouse details, reviews, coupons and practical buying tips — all organized in one place.',
    searchPlaceholder: 'Search USFans products, spreadsheet links, QC, shipping or guides...',
    ctaPrimary: 'USFans Spreadsheet',
    ctaSecondary: 'Buy It Now',
    dropdownLabel: 'Choose a category',
    dropdownHint: 'Jump to a category on the main website',
    trustLine: 'Free resource · No account required · Updated regularly',
  },
  intro: {
    title: 'What Is the USFans Spreadsheet?',
    p1: 'The USFans Spreadsheet is a centralized, organized resource that gathers product links, quality-check (QC) details, shipping notes and buying guidance for streetwear and fashion shoppers. Instead of digging through endless pages or chat threads, buyers use one tidy document to compare products and find exactly what they need.',
    p2: 'It works as a practical starting point: pick a category, scan the listed items, review the QC and sizing notes, then open the link you want on the main website. Everything you need for a confident purchase is kept in one place.',
    point1: 'Product links grouped by category',
    point2: 'QC and sizing references',
    point3: 'Shipping and warehouse guidance',
    point4: 'Coupon and discount pointers',
  },
  categoriesSection: {
    title: 'Popular Categories',
    subtitle: 'Open any category below to browse matching products on the main website.',
  },
  qc: {
    title: 'QC & Quality Checks',
    body: 'QC stands for quality check. Before an item ships, buyers often review photos to confirm the color, logo, stitching, size and overall condition. A solid QC routine means checking measurements against a size chart and asking for clearer photos when anything looks off.',
    item1: 'Review photos before shipment',
    item2: 'Check measurements against the size chart',
    item3: 'Ask for new photos if details are unclear',
    item4: 'Confirm color, logo and stitching',
  },
  review: {
    title: 'USFans Review — Is It Legit?',
    body: 'USFansLink.site is an independent informational resource, not an official brand page. Whether a purchase is safe depends on verifying the seller, reading reviews from several sources and using secure payment methods.',
    legitTitle: 'Legit & Safe Buying',
    legit1: 'Verify the seller before paying',
    legit2: 'Read reviews from multiple sources',
    legit3: 'Use secure, traceable payment methods',
    legit4: 'Be cautious with suspicious links',
  },
  shipping: {
    title: 'Shipping Cost & Delivery',
    body: 'Shipping cost and delivery time depend on your destination, the shipping method and the package size. Some buyers consolidate several items through a warehouse to lower the total cost.',
    item1: 'Confirm shipping cost before ordering',
    item2: 'Check estimated delivery time for your country',
    item3: 'Consider warehouse consolidation for multiple items',
  },
  warehouse: {
    title: 'Warehouse & Storage',
    body: 'Orders are usually packed and inspected at a warehouse before shipping. Warehouse services can hold, inspect and combine items so you ship several products together and pay less overall.',
  },
  coupon: {
    title: 'Coupons & Discounts',
    body: 'Coupon codes change frequently, so treat any code as temporary. Test it at checkout and only use codes from sources you trust. The spreadsheet may point you to current offers or explain where discounts are usually published.',
  },
  safety: {
    title: 'Safety Center',
    body: 'Stay safe while shopping: avoid fake websites, verify links, protect your payment details and double-check any offer that looks too good to be true.',
    item1: 'Watch for fake or copycat websites',
    item2: 'Never share passwords or payment details carelessly',
    item3: 'Verify coupon codes before checkout',
    item4: 'Double-check suspicious links',
  },
  articles: {
    title: 'Latest Articles',
    subtitle: 'Original guides to help you use the USFans Spreadsheet with confidence.',
    cardTitle: 'USFans Spreadsheet: The Complete Guide',
    cardDesc: 'A clear walkthrough of what the USFans Spreadsheet covers, how to use it, and how to shop safely — from product categories to QC, shipping and coupons.',
    readMore: 'Read the guide',
    tag: 'Guide',
  },
  faq: {
    title: 'Frequently Asked Questions',
    q1: 'What is the USFans Spreadsheet?',
    a1: 'It is a centralized resource that gathers product links, categories, QC information, shipping notes and buying guidance in one organized place.',
    q2: 'Is USFansLink.site an official USFans page?',
    a2: 'No. This is an independent informational resource and does not claim official affiliation.',
    q3: 'How do I use the category links?',
    a3: 'Pick a category from the dropdown or the category buttons, then open the matching link to browse products on the main website.',
    q4: 'Are prices and shipping costs always current?',
    a4: 'No. Prices, shipping and promotions can change, so always verify them on the product page before you pay.',
    q5: 'Is it safe to buy?',
    a5: 'Safety depends on verifying the seller, reading reviews and using secure payment methods. Be cautious with unknown links and offers that look too good to be true.',
  },
  cta: {
    title: 'Ready to Browse the Full USFans Spreadsheet?',
    body: 'Open the main website to explore products, check QC details and compare options — all in one place.',
    button: 'Continue to the Main Website',
  },
  disclaimer: 'USFansLink.site is an independent informational resource. External links, products, prices, shipping information and promotions may change. Always verify current information before making a purchase or payment.',
  },
};